<template>
    <el-dialog
        title="供应商评分表"
        class="key-data-trans-person-dialog"
        :append-to-body="true"
        :visible.sync="visible"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="!confirmLoading && !pdfTransforming"
        ref="dialogRef"
        width="98%"
        top="3vh"
        :before-close="close"
    >
        <div v-loading="loading" class="content-wrap" ref="contentRef">
            <div class="title-container">
                <span class="title">供应商基础信息</span>
            </div>
            <PersonBaseInfo ref="biRef" :pdfTransforming="pdfTransforming" />
            <div class="title-container">
                <span class="title">资质信息</span>
            </div>
            <el-table :data="qlfTableData" :span-method="arraySpanMethod" border header-row-class-name="header-bg" class="margin-bottom-20">
                <el-table-column prop="businessType" label="业务类型" width="120"></el-table-column>
                <el-table-column prop="propertyNature" label="主体性质" width="120"></el-table-column>
                <el-table-column prop="zzlx" label="资质类型">
                    <template slot-scope="scope">
                        <div v-html="scope.row.zzlx"></div>
                    </template>
                </el-table-column>
                <el-table-column prop="qualificationFlag" label="是否符合" width="180">
                    <template slot="header" slot-scope="scope">
                        <span class="required">*</span><span>是否符合</span>
                    </template>
                    <template slot-scope="scope">
                        <el-radio v-model="scope.row.qualificationFlag" label="符合">符合</el-radio>
                        <el-radio v-model="scope.row.qualificationFlag" label="不符合">不符合</el-radio>
                    </template>
                </el-table-column>
                <el-table-column prop="sm" label="说明"></el-table-column>
                <el-table-column prop="resultFlag" label="结果" width="100"></el-table-column>
            </el-table>
            <div class="title-container">
                <span class="title">能力评估</span>
                <div class="sub-title">1、运营能力（本项由运营平台负责修订）</div>
            </div>
            <el-table :data="operationTableData" :span-method="opArraySpanMethod" border header-row-class-name="header-bg" class="margin-bottom-20">
                <el-table-column prop="pgwd" label="评估维度" width="140"></el-table-column>
                <el-table-column prop="wdsm" label="维度说明"></el-table-column>
                <el-table-column prop="zf" label="总分" width="100"></el-table-column>
                <el-table-column prop="df" label="得分" width="100">
                    <template slot="header" slot-scope="scope">
                        <span class="required">*</span><span>得分</span>
                    </template>
                    <template slot-scope="scope">
                        <el-input :class="scoreError(scope.row.df, scope.row.zf) ? 'is-error' : ''" v-model.trim="scope.row.df" placeholder="输入分数"></el-input>
                    </template>
                </el-table-column>
                <el-table-column prop="resultFlag" label="结果" width="100"></el-table-column>
            </el-table>
            <div class="require-title">评审要求</div>
            <div class="require-rule margin-bottom-20">1、评审规则：资质信息任一项不符合不得引入；运营能力、服务品质各项总得分低于该项总分80%不得引入。</div>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button :disabled="confirmLoading || pdfTransforming" @click="close">取 消</el-button>
            <el-button type="primary" :loading="confirmLoading || pdfTransforming" @click="confirm">确认提交</el-button>
            <!-- <el-button @click="generateAndUploadPDF('供应商评分表-运输【个体】.pdf')">生成PDF并上传</el-button> -->
        </span>
    </el-dialog>
</template>
<script>
import Decimal from 'decimal.js'
import PersonBaseInfo from './PersonBaseInfo.vue'
import scoreMixin from './scoreMixin.js';
import { onlineDetail, onlineSave } from '../../../../../../api/qualification.js';

// SRM_BASIC_QUALITY 供应商评分表-运输【个体】
const TYPE = '36'

const INIT_QT = [
    { businessType: '运输', propertyNature: '个体', zzlx: '司机证件（驾驶证、行驶证、身份证）', qualificationFlag: '', sm: '原则上此项中任何一条不符合不得引入。有特殊需求需走供应商特批引入。', resultFlag: '' },
    { businessType: '', propertyNature: '', zzlx: '车辆证件（营运证、交强险、商业险、第三者责任险不低于100万）', qualificationFlag: '', sm: '', resultFlag: '' },
    { businessType: '', propertyNature: '', zzlx: '车辆、车主、司机彩色相片', qualificationFlag: '', sm: '', resultFlag: '' },
    { businessType: '', propertyNature: '', zzlx: '裙带关系：<br />1、与安得当地员工无亲属关系；<br />2、不是安得离职员工', qualificationFlag: '', sm: '', resultFlag: '' },
    { businessType: '', propertyNature: '', zzlx: '年检达标：车辆相关检查达到标准', qualificationFlag: '', sm: '', resultFlag: '' },
    { businessType: '', propertyNature: '', zzlx: '司机驾龄：司机驾龄不低于1年', qualificationFlag: '', sm: '', resultFlag: '' },
    { businessType: '', propertyNature: '', zzlx: '黑名单历史：无扣货历史，个人征信正常', qualificationFlag: '', sm: '', resultFlag: '' },
]

const INIT_OT = [
    { pgwd: '车辆风险（车况）', wdsm: '是否配备灭火器，并在有效期内', pfbz: '', zf: '20', df: '', resultFlag: '' },
    { pgwd: '', wdsm: '车厢及底板平整，无明显突出', pfbz: '', zf: '20', df: '', resultFlag: '' },
    { pgwd: '', wdsm: '无破损裸露外接电线，车底面无漏油痕迹', pfbz: '', zf: '20', df: '', resultFlag: '' },
    { pgwd: '', wdsm: '轮胎胎面完好、胎压正常、无严重磨损', pfbz: '', zf: '20', df: '', resultFlag: '' },
    { pgwd: '', wdsm: '是否有禁行区域的具备通行证的备案车辆', pfbz: '', zf: '10', df: '', resultFlag: '' },
    { pgwd: '', wdsm: '车龄（3年以下，3-5年，5年以上）', pfbz: '', zf: '10', df: '', resultFlag: '' },
    { pgwd: '加分项', wdsm: '同行业经验：是否有该客户所属行业承运方式工作经验', pfbz: '', zf: '10', df: '', resultFlag: '' },
    { pgwd: '', wdsm: '环保：是否为国V以上车辆', pfbz: '', zf: '5', df: '', resultFlag: '' },
    { pgwd: '', wdsm: '车身广告：是否接受车身广告', pfbz: '', zf: '3', df: '', resultFlag: '' },
]

export default {
    components: { PersonBaseInfo },
    mixins: [scoreMixin],
    data() {
        return {
            // SRM_YES,
            // currentId: null,
            // currentVersion: null,
            currentRow: null,
            visible: false,
            loading: false,
            confirmLoading: false,

            qlfTableData: JSON.parse(JSON.stringify(INIT_QT)),
            operationTableData: JSON.parse(JSON.stringify(INIT_OT)),
        };
    },
    methods: {
        open(row) {
            this.currentRow = row
            this.setUploadQlfForm(row)
            this.visible = true
            this.loading = true
            onlineDetail({ supplierCode: row.qualificationTypeCode, id: row.id }).then(res => {
                if (res && +res.code === 0) {
                    this.setData(res.data, JSON.parse(res.data.onlineContent || null))
                }
            }).finally(() => { this.loading = false })
        },
        close() {
            this.visible = false
            this.$refs.biRef.reset()
            this.qlfTableData = JSON.parse(JSON.stringify(INIT_QT))
            this.operationTableData = JSON.parse(JSON.stringify(INIT_OT))
        },
        setData(baseInfo, data) {
            this.$refs.biRef.setBaseInfo(baseInfo)
            if (!data) {
                return false
            }
            this.$refs.biRef.setFormData(data.supplierInfo)
            this.qlfTableData[0].resultFlag = data.supplierQualification.resultFlag
            this.qlfTableData.forEach((item, index) => {
                item.qualificationFlag = data.supplierQualification['qualification' + (index + 1) + 'Flag']
            })
            this.operationTableData[0].resultFlag = data.operationalCapability.resultFlag
            this.operationTableData.forEach((item, index) =>  {
                if (index < 6) {
                    item.df = data.operationalCapability['risk' + (index + 1) + 'Score']
                } else {
                    item.df = data.operationalCapability['addScore' + (index - 5)]
                }
            })
        },
        confirm() {
            const supplierInfo = this.$refs.biRef.getData()
            // 资质信息-是否符合-必填校验
            const qlfValid = this.qlfTableData.every(item => !!item.qualificationFlag)
            const scoreValid = this.scoreValidate()
            if (supplierInfo && qlfValid && scoreValid) {
                this.generateAndUploadPDF(this.currentRow.qualificationName + '.pdf', () => {
                    this.confirmLoading = true
                    onlineSave(this.getParams()).then(res => {
                        if (res && +res.code === 0) {
                            this.$message.success('提交成功!')
                            this.$emit('submit', this.getParamsFromUpload())
                            this.close()
                        }
                    }).finally(() => { this.confirmLoading = false })
                })
            } else {
                this.$message({
                    type: 'warning',
                    message: '请输入必填信息，家庭住址字长不能超过100位，其他字长不能超过20位，得分列请输入数字，可保留两位小数!',
                    duration: 4000,
                })
            }
        },
        getParams() {
            const params = {
                type: TYPE,
                onlineContent: '',
                ...this.getParamsFromUpload()
            }
            const supplierInfo = this.$refs.biRef.getData()
            const supplierQualification = {
                resultFlag: this.qlfTableData[0].resultFlag,
            }
            this.qlfTableData.forEach((item, index) => {
                supplierQualification['qualification' + (index + 1) + 'Flag'] = item.qualificationFlag
            })
            const operationalCapability = {
                resultFlag: this.operationTableData[0].resultFlag,
            }
            this.operationTableData.forEach((item, index) => {
                if (index < 6) {
                    operationalCapability['risk' + (index + 1) + 'Score'] = item.df
                } else {
                    operationalCapability['addScore' + (index - 5)] = item.df
                }
            })
            params.onlineContent = JSON.stringify({ supplierInfo, supplierQualification, operationalCapability })
            return params
        },
        // 所有得分项格式校验
        scoreValidate() {
            const oError = this.operationTableData.some(item => this.scoreError(item.df, item.zf))
            return !oError
        },
        arraySpanMethod({ row, column, rowIndex, columnIndex }) {
            if ([0, 1, 4, 5].includes(columnIndex)) {
                if (rowIndex === 0) {
                    return [7, 1];
                } else {
                    return [0, 0];
                }
            }
        },
        opArraySpanMethod({ row, column, rowIndex, columnIndex }) {
            if (columnIndex === 0) {
                if (rowIndex === 0) {
                    return [6, 1];
                } else if (rowIndex === 6) {
                    return [3, 1];
                } else {
                    return [0, 0];
                }
            } else if (columnIndex === 4) {
                if (rowIndex === 0) {
                    return [9, 1];
                } else {
                    return [0, 0];
                }
            }
        },
        scoreError(score, max) {
            // 不是可保留两位小数的数字格式 || 大于最大值
            return !/^\d+(\.\d{1,2})?$/.test(score) || Number(score) > Number(max)
        },
    },
    watch: {
        qlfTableData: {
            handler(val) {
                if (!this.visible) {
                    return val[0].resultFlag = ''
                }
                val[0].resultFlag = val.some(item => !item.qualificationFlag || item.qualificationFlag === '不符合') ? '不通过' : '通过'
            },
            deep: true,
        },
        operationTableData: {
            handler(val) {
                if (!this.visible) {
                    return val[0].resultFlag = ''
                }
                val[0].resultFlag = val.some(item => Number(item.df) > Number(item.zf) || Number(item.df) < Decimal.mul(item.zf, 0.8).toNumber()) ? '不通过' : '通过'
            },
            deep: true,
        },
    }
}
</script>
<style lang="less">
.key-data-trans-person-dialog {
    .el-dialog {
        margin-bottom: 0;
    }

    .el-dialog__body {
        overflow-y: scroll;
        padding: 0;
        height: calc(94vh - 113px);
        box-sizing: border-box;
    }

    .content-wrap {
        padding: 16px;
    }

    .title-container {
        // margin-bottom: 5px;
        font-size: 16px;
        color: #000;

        // i {
        //     float: right;
        //     padding-right: 10px;
        //     font-size: 24px;
        //     cursor: pointer;
        // }
    }

    .title {
        display: inline-block;
        font-weight: bold;

        &::before {
            display: inline-block;
            // border-radius: 50%;
            margin-right: 5px;
            width: 5px;
            height: 14px;
            background: #000;
            content: '';
            vertical-align: middle;
        }
    }

    .sub-title {
        padding: 5px 10px;
        font-size: 14px;
        color: #000;
        background-color: #f2f2f2;
    }

    .el-table {
        // border-right: 1px solid #ebeef5;

        .cell {
            white-space: normal;
        }

        .header-bg th {
            background: #f5f7fa;
        }
    }

    .margin-bottom-20 {
        margin-bottom: 20px;
    }

    .require-title {
        font-size: 16px;
        color: #000;
    }

    .el-dialog__footer {
        padding-top: 15px;
        padding-bottom: 15px;
        text-align: center;
        border-top: 1px solid #d7d7d7;

        .el-button + .el-button {
            margin-left: 30px;
        }
    }

    .required {
        color: #f96c5f;
    }

    .is-error input {
        border-color: #f96c5f;
    }
}
</style>